import React from "react";
const RemoveIcon = (props) => /* @__PURE__ */ React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M16.23 7l.77.77L12.769 12 17 16.23l-.77.77L12 12.769 7.77 17 7 16.23 11.23 12 7 7.77 7.77 7 12 11.231 16.23 7z"
  }
));
export {
  RemoveIcon
};
//# sourceMappingURL=RemoveIcon.js.map
